import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { StoreState } from '@mm/state/store-interfaces';
import { StartBotPromoterPanel } from '../../../common/StartBotPromoterPanel/StartBotPromoterPanel';
import { useCreateStartBotPromoterByType } from '../../../common/use-create-start-bot-promoter-by-type';

const useNaggerDeepLink = () => {
  const { location } = useRouter();
  const connectedPage = useSelector((state: StoreState) =>
    activeFacebookPageSelector(state),
  );
  const createCommentGuard =
    useCreateStartBotPromoterByType('fb_comment_guard');

  useEffect(() => {
    const newCGPath =
      location.pathname && location.pathname.split('/')[4] === 'new';

    if (newCGPath) {
      const pageName = (connectedPage && connectedPage.name) || 'my page';
      const cgNaggerMessage = `Thank you for commenting on our post, would you like to subscribe to occasional updates from ${pageName}?`;

      createCommentGuard(cgNaggerMessage);
    }
  }, []);
};

export const CommentGuardPanel = () => {
  useNaggerDeepLink();

  return <StartBotPromoterPanel kind="fb_comment_guard" />;
};
